<template>
  <div class="md-layout">
    <md-dialog
      :md-active.sync="showNotesDialog"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
      id="notes-dialog"
    >
      <md-dialog-title>{{ title }}</md-dialog-title>
      <div class="md-layout md-alignment-bottom-left note-input mt-4">
        <div class="md-layout-item md-size-100">
          <label class="caption" style="margin-bottom:0.5rem; display:block;"
            >Something to say?</label
          >
          <text-editor v-model="newNoteContent" />
        </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary md-dense" @click="cancel"
          >Cancel</md-button
        >
        <md-button class="md-primary md-dense" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "NotesDialog",

  props: {
    showNotesDialog: Boolean,
    note: {
      type: Object,
      default: () => ({ content: null, id: null })
    },
    title: {
      type: String,
      default: "Notes"
    }
  },

  components: {},

  methods: {
    save() {
      this.note.content = this.newNoteContent;
      this.$emit("saveNote", this.note);
    },

    cancel() {
      this.$emit("update:showNotesDialog", false);
    }
  },

  watch: {
    note() {
      this.newNoteContent = this.note.content;
    }
  },

  computed: {},

  data() {
    return {
      newNoteContent: null
    };
  }
};
</script>

<style lang="scss" scoped>
.note-input {
  margin-bottom: 0.5em;
}
#notes-dialog {
  &::v-deep .md-dialog-container {
    max-width: 768px;
    min-width: 768px;
    width: 768px;
  }
}
</style>
